/* esm.sh - applesauce-common@5.2.0/dist/casts/mutes */
export * from "/*applesauce-common@5.2.0/esnext/dist/casts/mutes.mjs";
